"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _reducers = require("../../reducers");

var _utils = require("../Annotations/utils");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var POINTER_EVENTS_SUPPORTED = !!window.PointerEvent;

var removeAnnotationBodyClasses = function removeAnnotationBodyClasses() {
  document.body.classList.remove('ccx-comments-adding-annotation-pin', 'ccx-comments-adding-annotation-highlight', 'ccx-comments-adding-annotation-insert', 'ccx-comments-adding-annotation-replace', 'ccx-comments-adding-annotation-strikethrough');
};

var useAnnotatingBodyClasses = function useAnnotatingBodyClasses() {
  var store = (0, _reducers.useStore)();
  var _store$getState$ = store.getState()["".concat(_constants.PREFIX, ":context")],
      newAnnotationType = _store$getState$.newAnnotationType,
      isPlacingAnnotation = _store$getState$.isPlacingAnnotation;
  var handleMouseMove = (0, _react.useCallback)((0, _lodash.default)(function (evt) {
    var _getClientCoordinates = (0, _utils.getClientCoordinatesFromEvent)(evt),
        x = _getClientCoordinates.x,
        y = _getClientCoordinates.y;

    var isOverOverlay = false;
    var querySelectors = ['.addining-annotation-pin', '.addining-annotation-highlight', '.addining-annotation-insert', '.addining-annotation-replace', '.addining-annotation-strikethrough'];
    Array.from(document.querySelectorAll(querySelectors.join())).forEach(function (overlay) {
      var rect = overlay.getBoundingClientRect();

      if (x >= rect.left && x <= rect.left + rect.width) {
        if (y >= rect.top && y <= rect.top + rect.height) {
          isOverOverlay = true;
        }
      }
    });

    if (isOverOverlay) {
      document.body.classList.add("ccx-comments-adding-annotation-".concat(newAnnotationType));
    } else {
      removeAnnotationBodyClasses();
    }
  }, 10, {
    leading: true,
    maxWait: 30
  }), [newAnnotationType]);
  (0, _react.useEffect)(function () {
    if (isPlacingAnnotation) {
      if (POINTER_EVENTS_SUPPORTED) {
        window.addEventListener('pointermove', handleMouseMove, true);
      } else {
        window.addEventListener('mousemove', handleMouseMove, true);
        window.addEventListener('touchmove', handleMouseMove, true);
      }
    }

    return function () {
      if (POINTER_EVENTS_SUPPORTED) {
        window.removeEventListener('pointermove', handleMouseMove, true);
      } else {
        window.removeEventListener('mousemove', handleMouseMove, true);
        window.removeEventListener('touchmove', handleMouseMove, true);
      }
    };
  }, [isPlacingAnnotation, handleMouseMove]);
  (0, _react.useEffect)(function () {
    return function () {
      removeAnnotationBodyClasses();
    };
  }, []);
};

var _default = useAnnotatingBodyClasses;
exports.default = _default;